import React from "react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faUserCircle} from "@fortawesome/free-solid-svg-icons";
const ChatMessage=({name,message})=><div className="flex items-start gap-2 rounded-lg px-2 py-1.5 hover:bg-[#272727]"><FontAwesomeIcon icon={faUserCircle} className="mt-0.5 text-lg text-[#aaa]"/><div className="min-w-0 text-sm"><span className="mr-2 font-semibold text-white">{name}</span><span className="break-words text-[#ddd]">{message}</span></div></div>;
export default ChatMessage;
